import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Button } from '../../../components/ui/button';
import { Card } from '../../../components/ui/card';
import { ArrowLeft, Key } from 'lucide-react';

export default function AuthSettings() {
  const { orgId } = useParams();
  const navigate = useNavigate();

  return (
    <div className="p-8 space-y-6">
      <div className="flex items-center gap-4">
        <Button variant="ghost" size="sm" onClick={() => navigate(`/enterprise/orgs/${orgId}/settings`)}>
          <ArrowLeft className="w-4 h-4 mr-2" />
          Back
        </Button>
        <div>
          <h1 className="font-heading text-2xl font-bold text-gray-900">Authentication & SSO</h1>
          <p className="text-gray-600 mt-1">Configure single sign-on and authentication methods</p>
        </div>
      </div>

      <Card className="p-6 rounded-lg">
        <h3 className="font-semibold text-gray-900 mb-4">SSO Providers</h3>
        <div className="space-y-3">
          <div className="flex items-center justify-between p-4 rounded-lg border border-gray-200">
            <div>
              <p className="font-semibold">Microsoft 365 / Azure AD</p>
              <p className="text-sm text-gray-600">SAML 2.0 / OIDC</p>
            </div>
            <Button variant="outline" size="sm">
              Configure
            </Button>
          </div>
          <div className="flex items-center justify-between p-4 rounded-lg border border-gray-200">
            <div>
              <p className="font-semibold">Google Workspace</p>
              <p className="text-sm text-gray-600">OAuth 2.0</p>
            </div>
            <Button variant="outline" size="sm">
              Configure
            </Button>
          </div>
          <div className="flex items-center justify-between p-4 rounded-lg border border-gray-200">
            <div>
              <p className="font-semibold">Okta</p>
              <p className="text-sm text-gray-600">SAML 2.0</p>
            </div>
            <Button variant="outline" size="sm">
              Configure
            </Button>
          </div>
        </div>
      </Card>

      <Card className="p-6 rounded-lg">
        <h3 className="font-semibold text-gray-900 mb-4">Authentication Methods</h3>
        <div className="space-y-3">
          <div className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
            <span className="text-sm text-gray-700">Email & Password</span>
            <span className="text-sm text-success">Enabled</span>
          </div>
          <div className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
            <span className="text-sm text-gray-700">SSO Only Mode</span>
            <span className="text-sm text-gray-500">Disabled</span>
          </div>
        </div>
      </Card>
    </div>
  );
}
